import React from 'react';

var GameBackside = function (_a) {
    var refProp = _a.refProp, children = _a.children;
    return (React.createElement("div", { className: 'pgc-game-backside', ref: refProp }, children));
};

export { GameBackside };
